import comps from 'components';

export type LibProperties = typeof comps;

export default comps;
